// extracted by mini-css-extract-plugin
module.exports = {"rank":"RankingIcon_rank__KlYaM","rank-first":"RankingIcon_rank-first__TzFdu","rank-second":"RankingIcon_rank-second__GlR67","rank-third":"RankingIcon_rank-third__lPE1w"};